import { Box, Card, Grid, Typography } from "@mui/joy";
import { additionalSx } from "@utils/additionalSx";

export function StatWidgetTitle(props) {
    return (
        //component="h2" variant="h6"
      <Typography color="primary" fontWeight={'bold'} gutterBottom>
        {props.children}
      </Typography>
    );
}

export function StatWithIcon(props) {
    return <Typography level="h1" startDecorator={props.icon ?? null}>{props.text}</Typography>;
}

export function StatSubtext(props) {
    return (
        //  fontSize={'sm'}
      <Typography color="primary" fontSize={'xs'}>
        {props.children}
      </Typography>
    );
}

export default function StatWidgetCell(props) {

    return (
        <Box gridColumn="span 3" sx={{height: '100%'}}>
            <Card
                sx={theme => ({
                height: '100%',
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                // height: 240,
                border: 0,
                boxShadow: 'md',
                backgroundColor: props.color ?? '#fff',
                /*
                background: `
                    ${props.color ?? '#fff'}
                    radial-gradient(
                        12vw circle at 108% 0px,
                        ${props.color ? 'rgba(255,255,255,0.18)' : 'rgba(0,0,0,0.04)'} 50%,
                        ${props.color ?? '#fff'} 51%
                    )
                `,
                */
                color: props.textColor ?? '#000',
                '*': {
                    color: `${props.textColor ?? '#000'} !important`,
                },
                ...additionalSx(theme, props?.sx),
                })}
            >
            {props.children}
            </Card>
        </Box>
    );
}
